<template>
    <div class="form-section">
      <template v-if="$store.getters['user/isHirer']">
        <div
          class="form-group vanilla"
          :class="{ 'has-input-error': errors.abn }"
        >
          <label :for="`profile-abn_${this._uid}`"
            >ABN <span class="required">*</span></label
          >
          <input
            :id="`profile-abn_${this._uid}`"
            type="text"
            name="abn"
            maxlength="11"
            v-model="data.abn"
            @blur="fetchBusinessName"
            required
            placeholder="Enter ABN"
          />
          <input-error v-if="errors.abn">
            {{ errors.abn[0] }}
          </input-error>
        </div>
        <div
          class="form-group vanilla"
          :class="{ 'has-input-error': errors.business_name }"
        >
          <label :for="`profile-business_${this._uid}`" class="business-name-wrap"
            >Business Name
            <transition name="fade" mode="out-in" appear :duration="250">
              <div v-if="business_input_loading">
                <p class="fg-dark-red">
                  {{ business_name_loading }}
                </p>
              </div>
            </transition>
          </label>
          <input
            :id="`profile-business_${this._uid}`"
            type="text"
            name="business_name"
            v-model="data.business_name"
            :disabled="true"
            required
          />
          <input-error v-if="errors.business_name">
            {{ errors.business_name[0] }}
          </input-error>
        </div>
        <div
          class="form-group vanilla"
          :class="{ 'has-input-error': errors.insurance_documents }"
        >
          <label :for="`attach-signed-schedule_${this._uid}`"
            >Insurance Documents</label
          >
          <attachment-uploader
            :id="`attach-signed-schedule_${this._uid}`"
            name="insurance_documents"
            :multiple="true"
            :accept="['application/pdf', 'application/word']"
            :max-file-size="10240"
            :max-items="6"
            :initial-value="data.insurance_documents"
            v-model="data.insurance_documents"
          ></attachment-uploader>
          <input-error v-if="errors.insurance_documents">
            {{ errors.insurance_documents[0] }}
          </input-error>
        </div>
        <div
          class="form-group vanilla"
          :class="{ 'has-input-error': errors.company_type }"
          v-if="
            typeof form_options !== 'undefined' &&
            typeof form_options.company_types !== 'undefined' &&
            form_options.company_types.length
          "
        >
          <label>Business type <span class="required">*</span></label>
          <select-wrapper
            id="company"
            name="company"
            :options="form_options.company_types"
            v-model="data.company_type"
            @input="delete errors.company_type"
            placeholder="Select Business type"
          ></select-wrapper>
          <input-error v-if="errors.company_type">
            {{ errors.company_type[0] }}
          </input-error>
        </div>
      </template>
      <template v-else>
        <div class="form-group vanilla">
          <checkbox
            class="form-group"
            v-model="isSelected"
            name="gst"
            @click="clickme"
            label="My Company Details are not applicable. ABN not required as I am not registered for GST for listing my property."
          ></checkbox>
        </div>
        <div
          class="form-group vanilla"
          :class="{ 'has-input-error': errors.insurance_documents }"
        >
          <label :for="`attach-signed-schedule_${this._uid}`"
            >Insurance Documents</label
          >
          <attachment-uploader
            :id="`attach-signed-schedule_${this._uid}`"
            name="insurance_documents"
            :multiple="true"
            :max-items="6"
            :initial-value="data.insurance_documents"
            v-model="data.insurance_documents"
          ></attachment-uploader>
          <input-error v-if="errors.insurance_documents">
            {{ errors.insurance_documents[0] }}
          </input-error>
        </div>
        <transition
          name="fade"
          mode="out-in"
          appear
          :duration="250"
          v-if="data.gst === 1 || isSelected === false"
        >
          <p class="fg-dark-red lister-message">
            You've indicated that you are listing your property under an ABN.
            Please note that you are responsible for reporting your taxable income
            to the Australian Taxation Office.
          </p>
        </transition>
        <transition
          name="fade"
          mode="out-in"
          appear
          :duration="250"
          v-if="data.gst === 1 || isSelected === false"
        >
          <div
            class="form-group vanilla"
            :class="{ 'has-input-error': errors.abn }"
          >
            <label :for="`profile-abn_${this._uid}`">ABN</label>
            <input
              :id="`profile-abn_${this._uid}`"
              type="text"
              name="abn"
              maxlength="11"
              v-model="data.abn"
              @blur="fetchBusinessName"
              required
            />
            <input-error v-if="errors.abn">
              {{ errors.abn[0] }}
            </input-error>
          </div>
        </transition>
        <transition
          name="fade"
          mode="out-in"
          appear
          :duration="250"
          v-if="data.gst === 1 || isSelected === false"
        >
          <div
            class="form-group vanilla"
            :class="{ 'has-input-error': errors.business_name }"
          >
            <label
              :for="`profile-business_${this._uid}`"
              class="business-name-wrap"
              >Business Name
              <transition name="fade" mode="out-in" appear :duration="250">
                <div v-if="business_input_loading">
                  <p class="fg-dark-red">
                    {{ business_name_loading }}
                  </p>
                </div>
              </transition>
            </label>
            <input
              :id="`profile-business_${this._uid}`"
              type="text"
              name="business_name"
              v-model="data.business_name"
              :disabled="disable_business_input ? disabled : ''"
              required
            />
            <input-error v-if="errors.business_name">
              {{ errors.business_name[0] }}
            </input-error>
          </div>
        </transition>
      </template>
    </div>
  </template>

  <script>
  import { mapGetters } from "vuex";

  const fields = {
    abn: "",
    gst: 0,
    errors: [],
    insurance_documents: {},
  };

  export { fields };

  export default {
    props: {
      data: {
        type: Object,
        required: true
      },
      errors: {
        required: true
      },
      form_options: {
        type: Object,
        required: false
      }
    },
    created() {
      this.isSelected = !this.account.gst;
    },

    data() {
      return {
        isSelected: !this.data.gst,
        disabled: false,
        disable_business_input: false,
        business_input_loading: false,
        business_name_loading: "Business Name is loading...",
      };
    },
    methods: {
      clickme() {
        if (this.data.gst == 0) {
          this.isSelected = 0;
        } else {
          this.isSelected = 1;
        }
        this.isSelected = !this.isSelected;

        this.$emit(this.isSelected ? "deselected" : "selected");
      },
      fetchBusinessName() {
        if (this.validateABN()) {
          this.errors = [];
        } else {
          this.errors = { abn: ["Please Enter Valid ABN Number"] };
          return;
        }
        this.disable_business_input = false;
        this.business_input_loading = true;

        axios
          .post("/api/auth/get-business-name", {
            abn_number: this.data.abn,
          })
          .then((response) => {
            this.business_input_loading = false;
            this.data.business_name = response.data.business_name;
            this.disable_business_input = true;
          })
          .catch((error) => {
            if (
              typeof error.response !== "undefined" &&
              error.response.status === 422
            ) {
              this.business_input_loading = false;
              this.data.business_name = "";
              this.errors = { abn: ["Provided ABN number is invalid"] };
              this.disable_business_input = true;
              return;
            }

            this.$toasted.show(error.response.data, {
              type: "error",
            });
          });
      },
      validateABN() {
        if (this.data.abn != null) {
          if (this.data.abn.length != 11 || isNaN(parseInt(this.data.abn)))
            return false;

          let weighting = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
          let firstDigitProcessed = parseInt(this.data.abn.charAt(0)) - 1;
          let weighted = firstDigitProcessed * weighting[0];

          for (var i = 1; i < this.data.abn.length; i++) {
            weighted += parseInt(this.data.abn.charAt(i)) * weighting[i];
          }

          return weighted % 89 == 0;
        }
      },
    },
    computed: {
      ...mapGetters({
        account: "user/account",
      }),
    },
  };
  </script>
